import * as devisConf from '@/configuration/devisConf';

export const SOUS_TYPE_NORMAL = 'Normal';
export const SOUS_TYPE_AVOIR = 'Avoir';
export const SOUS_TYPE_ACOMPTE = 'Acompte';
export const SOUS_TYPE_AVOIR_SUR_ACOMPTE = 'AvoirSurAcompte';

export const FACTURE_SOUS_TYPE = [
  { code: SOUS_TYPE_NORMAL, libelle: 'listeFactures.type.normal' },
  { code: SOUS_TYPE_AVOIR, libelle: 'listeFactures.type.credit' },
  { code: SOUS_TYPE_ACOMPTE, libelle: 'listeFactures.type.deposit' },
  { code: SOUS_TYPE_AVOIR_SUR_ACOMPTE, libelle: 'listeFactures.type.avoirSurAcompte' },
];

export const FACTURE_ETAT = [
  { code: devisConf.ETAT_ENREGISTRE, libelle: 'listeFactures.status.save' },
  { code: devisConf.ETAT_BROUILLON, libelle: 'listeFactures.status.draft' },
  { code: devisConf.ETAT_ANNULER, libelle: 'listeFactures.status.cancel' },
  { code: devisConf.ETAT_PAYE, libelle: 'listeFactures.status.paye' },
];
export const TYPE_EDITION_JUSTIFICATIF = 'JustifPose';
export const TYPE_EDITION_FACTURE = 'Facture';
export const TYPE_EDITION_FACTURE_MAIL = 'facture';
export const TYPE_EDITION_FACTURE_SEULE = 'FactureSeule';
export const TYPE_EDITION_FACTURE_SANS_LOGO = 'FactureSansLogo';
export const TYPE_EDITION_FACTURE_DUPLICATA = 'FactureDuplicata';
export const TYPE_EDITION_FACTURE_LETTRE_ANNULATION1 = 'FactureLettreAnnulation1';
export const TYPE_EDITION_FACTURE_LETTRE_ANNULATION2 = 'FactureLettreAnnulation2';
export const TYPE_EDITION_ETIQUETTE = 'EtiquetteFacture';

export const LISTE_CHOICE_EDITION_FACTURE = [
  {
    typeEdition: '',
    libelle: 'detail.edition.intervenantCopie',
    typeDonnee: TYPE_EDITION_FACTURE,
    extra: {
      type: 'boolean',
      param: 'grouperDansUnPdf',
      libelle: 'detail.edition.grouperDansUnPdf',
    },
  },
  {
    typeEdition: TYPE_EDITION_FACTURE_SEULE,
    libelle: 'detail.edition.factureSeule',
    typeDonnee: TYPE_EDITION_FACTURE,
    extra: {
      type: 'boolean',
      param: 'grouperDansUnPdf',
      libelle: 'detail.edition.grouperDansUnPdf',
    },
  },
  {
    typeEdition: TYPE_EDITION_FACTURE_SANS_LOGO,
    libelle: 'detail.edition.factureSansLogo',
    typeDonnee: TYPE_EDITION_FACTURE,
    extra: {
      type: 'boolean',
      param: 'grouperDansUnPdf',
      libelle: 'detail.edition.grouperDansUnPdf',
    },
  },
  {
    typeEdition: TYPE_EDITION_FACTURE_DUPLICATA,
    libelle: 'detail.edition.factureDuplicata',
    typeDonnee: TYPE_EDITION_FACTURE,
    extra: {
      type: 'boolean',
      param: 'grouperDansUnPdf',
      libelle: 'detail.edition.grouperDansUnPdf',
    },
  },
  {
    typeEdition: TYPE_EDITION_FACTURE_LETTRE_ANNULATION1,
    libelle: 'detail.edition.factureLettreAnnulation1',
    typeDonnee: TYPE_EDITION_FACTURE,
    extra: {
      type: 'boolean',
      param: 'grouperDansUnPdf',
      libelle: 'detail.edition.grouperDansUnPdf',
    },
  },
  {
    typeEdition: TYPE_EDITION_FACTURE_LETTRE_ANNULATION2,
    libelle: 'detail.edition.factureLettreAnnulation2',
    typeDonnee: TYPE_EDITION_FACTURE,
    extra: {
      type: 'boolean',
      param: 'grouperDansUnPdf',
      libelle: 'detail.edition.grouperDansUnPdf',
    },
  },
  { typeEdition: '', libelle: 'detail.edition.justificatifPose', typeDonnee: TYPE_EDITION_JUSTIFICATIF },
  { typeEdition: '', libelle: 'catalogue.edition.diaporama', typeDonnee: 'Diaporama' },
  { typeEdition: '', libelle: 'detail.edition.etiquette', typeDonnee: TYPE_EDITION_ETIQUETTE },
];

export const ACTION_EXPORT_PRELEVEMENT = 'ExportPrelevement';
export const ACTION_EXPORT_PRELEVEMENT_XLS = 'ExportPrelevementXls';
export const ACTION_SOLDER_MANUELLEMENT = 'SolderManuellement';
export const ACTION_REGENERATION_FACTURE_ACHAT = 'regenererFactureAchat';
export const ACTION_GENERATION_ECRITURE = 'generationEcriture';
export const ACTION_ENVOI_MAIL_MASSE = 'envoiMailEnMasse';

export const EXPORT_EXCEL_TYPE_EXPORT_PRELEVEMENT = 'prelevement';
export const EXPORT_EXCEL_TYPE_FACTURE = 'facture';
export const EXPORT_EXCEL_FACTURE_BAILLEUR = 'facturebailleur';
export const EXPORT_EXCEL_FACTURE_ACHAT = 'factureachat';
export const EXPORT_EXCEL_LIGNE_FACTURE = 'lignefactures';

export const TOTAL_RAPPROCHEMENT = 'Rapprochement_total';
export const PARTIEL_RAPPROCHEMENT = 'Rapprochement_partiel';
export const NO_RAPPROCHEMENT = 'Rapprochement_empty';
